var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoColsModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44358 0.555664H2.33247C1.35063 0.555664 0.554688 1.3516 0.554688 2.33344V9.44455C0.554688 10.4264 1.35063 11.2223 2.33247 11.2223H9.44358C10.4254 11.2223 11.2214 10.4264 11.2214 9.44455V2.33344C11.2214 1.3516 10.4254 0.555664 9.44358 0.555664Z",
    fill: "#71839B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6662 0.555664H16.5551C15.5733 0.555664 14.7773 1.3516 14.7773 2.33344V9.44455C14.7773 10.4264 15.5733 11.2223 16.5551 11.2223H23.6662C24.6481 11.2223 25.444 10.4264 25.444 9.44455V2.33344C25.444 1.3516 24.6481 0.555664 23.6662 0.555664Z",
    fill: "#71839B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44358 14.7778H2.33247C1.35063 14.7778 0.554688 15.5738 0.554688 16.5556V23.6667C0.554688 24.6486 1.35063 25.4445 2.33247 25.4445H9.44358C10.4254 25.4445 11.2214 24.6486 11.2214 23.6667V16.5556C11.2214 15.5738 10.4254 14.7778 9.44358 14.7778Z",
    fill: "#71839B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6662 14.7778H16.5551C15.5733 14.7778 14.7773 15.5738 14.7773 16.5556V23.6667C14.7773 24.6486 15.5733 25.4445 16.5551 25.4445H23.6662C24.6481 25.4445 25.444 24.6486 25.444 23.6667V16.5556C25.444 15.5738 24.6481 14.7778 23.6662 14.7778Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoColsModeIcon);
export default __webpack_public_path__ + "static/media/two-cols-mode-icon.bbd0924bfe7961584d264f2e26c708fe.svg";
export { ForwardRef as ReactComponent };